export function formatDuration(sec) {
  if (!sec || Number.isNaN(sec)) return "--:--";
  const s = Math.floor(sec);
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${m}:${rem.toString().padStart(2, "0")}`;
}

export function formatUploadDate(yyyymmdd) {
  if (!yyyymmdd || yyyymmdd.length < 8) return "";
  const y = yyyymmdd.slice(0, 4);
  const m = yyyymmdd.slice(4, 6);
  const d = yyyymmdd.slice(6, 8);
  return `${d}.${m}.${y}`;
}

// Returns "YYYY-MM-DDTHH:mm" suitable for datetime-local input
export function isoToLocalInput(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => n.toString().padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return "";
  }
}

// Convert yt-dlp "YYYYMMDD" upload_date into datetime-local default (noon)
export function ytDateToLocalInput(yyyymmdd) {
  if (!yyyymmdd || yyyymmdd.length < 8) return "";
  return `${yyyymmdd.slice(0, 4)}-${yyyymmdd.slice(4, 6)}-${yyyymmdd.slice(6, 8)}T12:00`;
}
